import * as React from 'react';
import { LoadIndicator } from 'devextreme-react/load-indicator';

const ComponentOverride = () => {
  return (
    <div>
        <LoadIndicator height={40} width={40} style={{position:"absolute", left:"50%", top:"10%"}}/>
      {/* <h1>This is a Custom Callback component</h1> */}
    </div>
  );
};

export default ComponentOverride;
